import { BehaviorSubject } from 'rxjs';
import { CONFIG } from 'config';

export type TFolderCodes = {
	[key: string]: string[];
};
export type TCode = {
	big: boolean;
	small: boolean;
	code: string;
};

export enum QR_SIZE {
	BIG = 'BIG',
	SMALL = 'SMALL',
}

export const API = `${CONFIG.apiUrl}/get_venging_qrcode`;

class SessionService {
	listOfCodes$: BehaviorSubject<TFolderCodes> = new BehaviorSubject<TFolderCodes>({});
	selectedCodes$: BehaviorSubject<TFolderCodes> = new BehaviorSubject<TFolderCodes>({});
	selectedCode$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
	hideTitle$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	static of() {
		return new SessionService();
	}
}

export const sessionStore = SessionService.of();

export type TPrepareCanvas = { active?: boolean; code: string; size: QR_SIZE; promise: Promise<HTMLCanvasElement> };

class CanvasService {
	listOfCanvas$: BehaviorSubject<TPrepareCanvas[]> = new BehaviorSubject<TPrepareCanvas[]>([]);

	static of() {
		return new CanvasService();
	}
}

export const canvasService = CanvasService.of();

export const MANUALLY_ADDED_FOLDER = 'ADDED';
